import script from "./UmbracoFormField.vue?vue&type=script&setup=true&lang=ts"
export * from "./UmbracoFormField.vue?vue&type=script&setup=true&lang=ts"

import "./UmbracoFormField.vue?vue&type=style&index=0&id=21f297a6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21f297a6"]])

export default __exports__